import './NavBar.scss';
import { connect } from 'react-redux';
import getAccount from 'stores/selectors/getAccount';
import getActiveIdentity from 'stores/selectors/getActiveIdentity';
import getIdentities from 'stores/selectors/getIdentities';
import NavBar from './NavBar';

const mapStateToProps = state => ({
  account: getAccount(state),
  currentIdentity: getActiveIdentity(state),
  identities: getIdentities(state),
});

const StatefulNavBar = connect(mapStateToProps)(NavBar);

export default StatefulNavBar;
